import { useSpeechRecognition } from "react-speech-recognition"

import { useVoiceManager } from "../hooks/use-voice-manager"
import { Ball3DVariants } from "./Ball3DVariants"
import { BallVariants } from "./BallVariants"
import { BallVariants as ShapeBallVariants } from "./ShapeVariants"
import { TubeVariants } from "./TubeVariants"

export function DevelopmentComponent() {
  const { allVoices, voiceCount } = useVoiceManager()
  const { browserSupportsContinuousListening } = useSpeechRecognition()

  return (
    <div className="foo-container">
      <ShapeBallVariants />
      <TubeVariants />

      <h1>Development Component</h1>
      <p className="">
        browserSupportsContinuousListening:{" "}
        {String(browserSupportsContinuousListening)}
      </p>
      <p className="">Available langs: {voiceCount}</p>
      <div className="flex flex-col overflow-y-auto">
        {allVoices.join(", ")}
      </div>

      <BallVariants />
      <Ball3DVariants />
    </div>
  )
}
